module.exports = __webpack_public_path__ + "img/teacherBanner.b14910dc.png";